module.exports = __webpack_public_path__ + "static/img/comfirmzh-tw.8d667d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirmzh-tw.png
// module id = g/MG
// module chunks = 1